
import AdditionalFieldsApi from '@/api/additionalFieldsApi'
const fields_api = new AdditionalFieldsApi()

import { eventBus } from '@/main'
import { mapGetters } from 'vuex'

import { snackbarMixin } from 'mixins'
import { tenderMixin } from 'mixins'

export default {
  mixins: [ snackbarMixin, tenderMixin ],
  data() {
    return {
      changedWinners: {},
      loadAgreement: false,
      changeWinnerMode: false,
      agree_loading: false,
      imAcceptor: null,
      can_edit: false,
      itemId: '',
      agreementFinished: false,
      item: {},
      loading: false,
    }
  },
  methods: {
    /**
     * Кликнули по тегу в чате
     */
    $_clickTagItem(clickParams) {
      const link = clickParams.params.tender !== this.itemId
      const baseUrl = window.location.origin + window.config.BaseUrl

      if (clickParams.type) {
        let tabName
        let href
        let dataQa
        switch (clickParams.type) {
        case 'lot': {
          tabName = 'lots'
          href = `${baseUrl}/${this.$route.params.org}/tenders/${clickParams.params.tender}/${clickParams.params.lot}`
          dataQa = `lot-key-${clickParams.params.lot}`
          break
        }
        case 'offer': {
          tabName = 'offers'
          href = `${baseUrl}/${this.$route.params.org}/tenders/${clickParams.params.tender}?tab=offers`
          dataQa = `offer-key-${clickParams.params.offer}`
          break
        }
        }
        const blinkRow = (dataQa) => {
          let rootItem
          setTimeout(() => {
            const itemFocus = document.querySelector(`[data-qa="${dataQa}"]`)
            rootItem = itemFocus ? itemFocus?.parentElement?.parentElement : null
            if (rootItem) {
              rootItem.scrollIntoView({block: 'center', behavior: 'smooth'})
              this.$nextTick(() => {
                rootItem.classList.remove('blink-row')
                rootItem.classList.add('blink-row')
                rootItem.onanimationend = () => {
                  rootItem.classList.remove('blink-row')
                }
              })
            }
          }, 1000)
        }
        if (link) {
          window.location.href = href
        } else {
          const indexTab = this.$refs.tabs.tabs.findIndex(i => i.value === tabName)

          if (indexTab !== -1 && indexTab !== this.$refs.tabs.tab) {
            this.$_openTab(indexTab)
            this.$nextTick(() => {
              blinkRow(dataQa)
            })
          } else {
            blinkRow(dataQa)
          }
        }
      }
    },
    $_openDocumentTab() {
      const indexTab = this.$refs.tabs.tabs.findIndex(i => i.value === 'documents')
      if (indexTab !== -1) {
        this.$_openTab(indexTab)
      }
      this.getItem
    },

    async $_agree(reason, decision, variables) {
      this.agree_loading = decision ? 'resolve' : 'reject'
      await this.$store.dispatch('tenderUserAgree', { tenderId: +this.$route.params.id, decision, reason: reason || '', variables})
        .then(res => {
          if ( res) {
            this.getItem(true)
          }
        })
        .catch(error => {
          this.$log_error(error.message)
          throw error
        })
        .finally(() => {
          this.agree_loading = false
        })
    },
    $_setAcceptorsProps(value) {
      this.loadAgreement = true
      if (!this.$_agreements?.length) {
        this.$set(this, 'can_edit', this.$_editing_rules)
        this.$set(this, 'imAcceptor', null)
      } else {
        this.$set(this, 'can_edit', this.$_checkCanEdit(this.item, this.$_agreements))
        this.$set(this, 'imAcceptor', this.$_checkImAcceptor(value?.agreements))
        this.$set(this, 'agreementFinished', this.$_checkAgreementFinished(value?.agreements?.acceptors))
      }
      this.loadAgreement = false
    },
    async $_getAdditionalFields() {
      return new Promise(async () => {
        if (this.item?.tenderId && this.$can('use', 'availableAdditionalFields')) {
          try {
            fields_api.getAdditionalFieldsByEntity({
              entityKey: this.item.tenderId + '',
            })
              .then(async resAdditional => {
                if (resAdditional?.length) {
                  let types = await this.$store.dispatch('setAdditionalFieldsTypes')

                  const resultMap = resAdditional?.map(field => ({
                    ...field,
                    type: types?.find(type => type.typeId == field.typeId)
                  })) || []

                  const tenderAdditionalFields = resultMap.filter(i => i.bindingLevel !== 'BID')

                  const bidAdditionalFields = resultMap.filter(i => i.bindingLevel === 'BID').map(i => {
                    return i.fieldValues.map(fieldValues => {
                      const value = i.typeId === 'JSON' ? JSON.parse(fieldValues.value) : {model: fieldValues.value}
                      return {
                        entityKey: +fieldValues.entityKey,
                        formType: i.typeId === 'JSON' ? value.formType.toLowerCase() : null,
                        value: value.model,
                        caption: i.caption,
                        type: i.typeId,
                        id: i.id
                      }
                    })
                  })

                  this.$set(this.item, 'additional_fields', tenderAdditionalFields)

                  const setAdditionalFieldToBid = (bidDetail, bidIndex, bidDetailIndex, additionalfields) => {
                    if (!additionalfields?.length) {
                      return
                    }
                    additionalfields.forEach((additionalfield) => {
                      additionalfield.forEach((additionalfieldItem) => {
                        if (additionalfieldItem.entityKey === bidDetail.id) {
                          const fieldName = additionalfieldItem.formType ? additionalfieldItem.formType : 'additionalFields'

                          if (this.item.bids[bidIndex].bidDetails[bidDetailIndex].additional_fields[fieldName]) {
                            this.item.bids[bidIndex].bidDetails[bidDetailIndex].additional_fields[fieldName].push(additionalfieldItem)
                          } else {
                            this.$set(this.item.bids[bidIndex].bidDetails[bidDetailIndex].additional_fields, fieldName, [additionalfieldItem])
                          }
                        }
                      })
                    })
                  }
                  this.item.bids.forEach((bid, bidIndex) => {
                    bid.bidDetails.forEach((bidDetail, bidDetailIndex) => {
                      this.$set(this.item.bids[bidIndex].bidDetails[bidDetailIndex], 'additional_fields', {})
                      this.$nextTick(() => {
                        setAdditionalFieldToBid(bidDetail, bidIndex, bidDetailIndex, bidAdditionalFields)
                      })
                    })
                  })
                }
              })
          } catch (_) {
            // ignore
          }
        }
      })
    },
    $_openTab(tab) {
      if (this.$refs.tabs) {
        this.$refs.tabs.tab = tab
      }
    },
    $_updateChangedWinners(items, quantity) {
      if (!items?.length) {
        this.changedWinners.bids ||= []
        this.changedWinners.bids.forEach(el => {
          this.item.bids.forEach(bid => {
            const selectedBid = bid.bidDetails.find(b => b.id === el.id)
            if (selectedBid) { selectedBid.selectedBid = !el.selectedBid }
          })
        })
        this.$root.$emit('offerTab_changeWinnerState', this.item.bids)
        return
      } else {
        items.forEach(item => {
          if (!item.selectedBid && item.selectedQuantity) {
            item.selectedQuantity = item.quantity
          }
        })
      }
      if (quantity) {
        this.changedWinners.quantity ||= []
        let it = this.changedWinners.quantity?.find(el => el.id == items[0].id)
        if (!it) {
          this.changedWinners.quantity.push(items[0])
        } else if (it.selectedQuantity == it.changedSelectedQuantity) {
          this.$_.remove( this.changedWinners.quantity, (el => el.id == it.id))
        }
      } else {
        this.changedWinners.bids = this.$_.xorBy(this.changedWinners.bids, items, 'id')
      }
    },
    async getItem(condition) {
      return new Promise(async (resolve) => {
        this.loading = true
        this.changedWinners = {}
        const currentTab = this.$refs.tabs ? this.$refs.tabs.tab : null

        await this.$store.dispatch('getTenderItem', {id: Number(this.$route.params.id), condition: condition})
          .then(async res => {
            await this.$_updateTenderAccess(res)
            this.$set(this, 'item', res || {})

            if (currentTab) {
              setTimeout(() => {
                this.$_openTab(currentTab)
              }, 100)
            }
          })
          .finally(() => {
            this.loading = false
            this.$_getAdditionalFields()
            resolve()
          /*
            Двойной запрос согласовантов
          if (this.$refs.tender_info_panel) {
            this.$refs.tender_info_panel.needLoadAgreements = true
            this.$refs.tender_info_panel.initTenderInfoPanelProps()
          }*/
          })
      })
    },
  },
  computed: {
    ...mapGetters('notification', [ 'isActiveSignalR']),
    $_disagreeFormioParams() {
      if (this.$_agreementForms) {
        return {
          formCode: this.$_agreementForms.disagreeFormCode || 'DISAGREE_FORM',
          version: this.$_agreementForms.disagreeFormVersion ?? 0,
          params: [
            {key: 'tenderId', value: this.item.tenderId.toString()}
          ]
        }
      }
      return null
    },
    $_agreeFormioParams() {
      if (this.$_agreementForms) {
        return {
          formCode: this.$_agreementForms.agreeFormCode || 'AGREE_FORM',
          version: this.$_agreementForms.agreeFormVersion ?? 0,
          params: [
            {key: 'tenderId', value: this.item.tenderId.toString()}
          ]
        }
      }
      return null
    },
    $_agreementForms() {
      if (!this.$_agreements?.length) {
        return null
      }
      return this.$_agreements.find(i => i.isMy && i.status == 'WAITING')
    },
    $_editing_rules() {
      return this.$acl.check('onlyTenders') && !this.item?.hasRoute
    },
    $_hasWinners() {
      return this.item?.tenderStatus?.id === this.statuseKeys.BID_ANALYSIS && this.item.bids.some(bid => bid.bidDetails.some(det => det.selectedBid))
    },
    /**
     * true, якщо серед групових лотів учасників є хоча б один, позначений
     * переможцем цілком (bidGroupDetails.bidDecisionAttribute === 'WINNER'),
     * але не всі його позиції мають власний bidDetails.bidDecisionAttribute
     * === 'WINNER' — тобто вибір переможця в межах групи частковий
     */
    $_hasPartialGroupWinners() {
      return !!this.item?.bids?.some(participant => participant.bidGroupDetails?.some(group => {
        if (group.bidDecisionAttribute !== 'WINNER') { return false }
        return group.bidDetails?.some(groupDetail => {
          const detail = participant.bidDetails?.find(det => det.id === groupDetail.id)
          return detail?.bidDecisionAttribute !== 'WINNER'
        })
      }))
    },
    $_canChangeWinners() {
      let status = this.item?.tenderStatus?.id
      return this.$can('change', 'tenderWinnerChangeMethodAccessibility')
        && (status == 10 || (status == 11 && !!this.item.participantCount))
        && !this.item?.biddingType?.isFrameFirstStage
    },
  },
  watch: {
    async '$route'(val, old) {
      if ( +val.params.id != +old.params.id) {
        if (!this.isActiveSignalR) {
          eventBus.$emit('ShowSignalAlert', 'Зміна сторінки тендера')
          return
        } else {
          await this.$notifier.outPage(this.itemId.toString(), 1)
        }
        this.itemId = this.$route.params?.id
        await this.getItem()
          .then(async () => {
            if (!this.isActiveSignalR) {
              eventBus.$emit('ShowSignalAlert', 'Отримання сторінки тендера')
              return
            } else {
              await this.$notifier.onPage(this.$route.params?.id?.toString(), 1)
            }
          })
      }
    },
    changeWinnerMode(val) {
      if (val) {
        this.$root.$on('changedWinnersFinishedTender', this.$_updateChangedWinners)
        this.$_openTab(1)
      } else {
        this.$root.$off('changedWinnersFinishedTender', this.$_updateChangedWinners)
        this.$_closeSnackbar()
        this.changedWinners = {}
      }
    }
  },
  async beforeDestroy() {
    if (!this.isActiveSignalR) {
      eventBus.$emit('ShowSignalAlert', 'Вихід з детальної тендера')
      return
    }
    await this.$notifier.outPage(this.itemId.toString(), 1)
    this.$root.$off('tenderUpdate', this.getItem)
    this.$root.$off('clickTagItem', this.$_clickTagItem)
  },
  async created() {
    this.itemId = this.$route.params?.id
    this.$root.$on('tenderUpdate', this.getItem)
    this.$root.$on('clickTagItem', this.$_clickTagItem)
    await this.getItem()
    if (!this.isActiveSignalR) {
      eventBus.$emit('ShowSignalAlert', 'Вхід на сторінку тендера')
      return
    }
    await this.$notifier.onPage(this.$route.params?.id?.toString(), 1)
  },
}
